import * as React from 'react';
import { useMemo } from 'react';
import VoxelText from '../../../../../../../../voxel/Text/VoxelText';
import { ComboRequestGq } from '../../../../../../../../../graphql/projects/models/ComboRequestGq';
import { QueuedItemStatus } from '../../../../../../../../../graphql/projects/models/QueuedItemStatus';
import VoxelChip from '../../../../../../../../voxel/Chips/VoxelChip';
import { VoxelAlertSeverity } from '../../../../../../../../voxel/Alert/VoxelAlert';

export interface ComboConversionStatusProps {
  comboRequest: ComboRequestGq;
}

const ComboConversionStatus: React.FC<ComboConversionStatusProps> = ({ comboRequest }) => {
  const analysis = useMemo(() => {
    return comboRequest.comboCombinations.reduce(
      (result, combination) => {
        if (!combination.selected) {
          return result;
        }

        if (combination.status === QueuedItemStatus.QUEUED) {
          return {
            ...result,
            total: result.total + 1,
            queued: result.queued + 1,
          };
        }
        if (combination.status === QueuedItemStatus.PROCESSING) {
          return {
            ...result,
            total: result.total + 1,
            processing: result.processing + 1,
          };
        }
        if (combination.status === QueuedItemStatus.SUCCEEDED) {
          return {
            ...result,
            total: result.total + 1,
            succeded: result.succeded + 1,
          };
        }
        if (combination.status === QueuedItemStatus.FAILED) {
          return {
            ...result,
            total: result.total + 1,
            failed: result.failed + 1,
          };
        }
        return result;
      },
      { queued: 0, processing: 0, failed: 0, succeded: 0, total: 0 }
    );
  }, [comboRequest]);

  if (analysis.total < 0) {
    return null;
  }

  let severity: VoxelAlertSeverity = 'neutral';
  if (analysis.processing > 0) severity = 'info';
  else if (analysis.succeded > 0) severity = 'success';
  else if (analysis.failed > 0) severity = 'warning';

  return <VoxelChip title={comboRequest.status} color={severity} />;
};

export default ComboConversionStatus;
